import Resource from '@/plugins/sdk/Resource'
import { BOOLEAN, DATETIME, STRING, UUID } from '@/plugins/sdk/fields'

export default class extends Resource {
  static name = 'ldap'

  static get fields () {
    return {
      id: new UUID(),
      user_name: new STRING(),
      name: new STRING(),
      created_at: new DATETIME(),
      updated_at: new DATETIME(),
      deleted: new BOOLEAN(),
      deleted_date: new DATETIME()
    }
  }
}
